import EventTypes from "./EventTypes";

const getBaseUrl = (p) => {
    let path = p.getURLPath();
    return `/${path[0]}/${path[1]}`;
}

const getPlanPath = (p) => {
    let path = p.getURLPath();
    return `/${path[0]}/${path[1]}/${path[2]}`;
}

const getUsername = (p) => {
    return p.getURLPath()[0];
}

const getPlanSlug = (p) => {
    return p.getURLPath()[2] == 'mobile' ? p.getURLPath()[3] : p.getURLPath()[2];
}

const isNewPlan = (p) => {
    return p.getURLPath()[1] == 'new';
}

const windowResized = (provider) => {
    provider.emit(EventTypes.RESIZE_WINDOW);
    // Need to use document for chrome because windowWidth/Height has a bug on chrome. https://github.com/processing/p5.js/issues/5130
    provider.p.resizeCanvas(document.documentElement.clientWidth, document.documentElement.clientHeight - (provider.touch ? 0 : 7));

    provider.zoomMenu.position();
    provider.speciesInfo.reposition();
}

const getTimestamp = () => {
    return Math.floor(Date.now() / 1000);
}

const focusInput = (input) => {
    if (input && input.visible) {
        // make sure the hot key is not entered in input
        setTimeout(
            () => input.focus(),
            10
        );
    }
}

const capitalize = (string) => {
    return string.charAt(0).toUpperCase() + string.slice(1);
}

const normalizeAngle = (angle) => {
    return angle % (Math.PI * 2);
}

const addSvg = (element, svgName, isInnerElement = false) => {
    let svg = SVG()
        .addTo(isInnerElement ? element : element.elt);
    svg.use(svgName, '/icons/__remixicon.sprite.svg');
    return svg;
}

const createRowButton = (p, parent, tooltip, func, svgId) => {
    let btn = p.createDiv()
        .parent(parent)
        .class('btn-icon mar-l-xs')
        .attribute('data-tooltip', tooltip)
        .mouseClicked(func);
    addSvg(btn, svgId);
    return btn;
}

export { getBaseUrl, getUsername, getPlanSlug, isNewPlan, windowResized, getTimestamp, focusInput, capitalize, getPlanPath, normalizeAngle, addSvg, createRowButton };
